export { upgrades as kusama } from './kusama.js';
export { upgrades as polkadot } from './polkadot.js';
export { upgrades as westend } from './westend.js';
